"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Description;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _DarkButton = _interopRequireDefault(require("../../Button/DarkButton"));

var TRIM_LENGTH = 125;
var s = {
  description: function description(theme, isTrimmed) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-size:12px;line-height:1.83;color:", theme.color.dark.iron, ";margin-top:8px;margin-bottom:", isTrimmed ? '8px' : '34px', ";")
    );
  },
  button:
  /*#__PURE__*/
  (0, _emotion.css)("font-size:12px !important;line-height:1.83 !important;margin-left:6px;")
};

function renderReadMoreLessButton(isTrimmed, setIsTrimmed) {
  var handleClick = function handleClick(event) {
    event && event.stopPropagation();
    setIsTrimmed(!isTrimmed);
  };

  return _react.default.createElement(_DarkButton.default.TextButton, {
    onClick: function onClick(event) {
      return handleClick(event);
    },
    className: s.button
  }, "read ", isTrimmed ? 'more' : 'less');
}

function Description(props) {
  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isTrimmed = _useState2[0],
      setIsTrimmed = _useState2[1];

  var showDescription = props.showDescription;

  if (!showDescription) {
    return null;
  }

  var theme = props.theme,
      description = props.description;
  var formattedDescription = isTrimmed ? description.substr(0, TRIM_LENGTH) : description;
  return _react.default.createElement("div", {
    title: description,
    className: s.description(theme, isTrimmed)
  }, formattedDescription, description.length > TRIM_LENGTH && renderReadMoreLessButton(isTrimmed, setIsTrimmed));
}